import type { Nivel } from '@persona/ui';

/**
 * Mapa fixo rota → nível (07 §0.1): login, início e módulo são Experience; rotina, Configurador e Diagnóstico são Work.
 * Dentro de /r/, o padrão do esquema decide: 'painel' é Experience.
 */
export function mapaRotaNivel(caminho: string, padrao?: string): Nivel {
  if (/^\/(cfg|diagnostico)(\/|$)/.test(caminho)) return 'work';
  if (/^\/r\//.test(caminho)) return padrao === 'painel' ? 'experience' : 'work';
  return 'experience';
}

export function aplicarNivel(nivel: Nivel) {
  const raiz = document.documentElement;
  if (raiz.dataset.nivel !== nivel) raiz.dataset.nivel = nivel;
}
